"use client";

import { useTranslation } from "@/hooks/useTranslation";
import type { Feedback } from "@/payload-types";

type Props = {
  feedback: Feedback;
};

export default function FeedbackCard({ feedback }: Props) {
  const { t } = useTranslation();
  return (
    <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
      {/* Card Header */}
      <div className="bg-primary-200 px-6 py-3">
        <h3 className="font-bold italic text-gray-700">
          {feedback.name}{" "}
          {feedback.country
            ? `${t({ en: "from", de: "aus" })} ${feedback.country}`
            : ""}
        </h3>
      </div>

      {/* Card Content */}
      <div className="p-6">
        {/* Date */}
        <div className="mb-4 text-sm text-gray-600">
          {new Date(feedback.createdAt).toLocaleDateString()}{" "}
          {new Date(feedback.updatedAt).toLocaleTimeString()}
        </div>

        {/* Message */}
        <div className="leading-relaxed text-gray-800">{feedback.messages}</div>
      </div>
    </div>
  );
}
